import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { formContextObj } from '../FormContainer/context';
import { getEstimation, clearAction as clearEstimationData } from '../../actions/getEstimation';
import { PriceEstimation } from '../../components/PriceEstimation';
import { selectEstimation } from '../../selectors/selectEstimation';

export const PriceEstimationContainer: React.FC = () => {
  const dispatch = useDispatch();
  const { data } = useSelector(selectEstimation);
  const { answersState } = React.useContext(formContextObj);

  React.useEffect(() => {
    dispatch(getEstimation({ answersState }));

    return () => {
      dispatch(clearEstimationData());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!data) {
    return null;
  }

  return <PriceEstimation {...data} />;
};

PriceEstimationContainer.displayName = 'PriceEstimationContainer';
